import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowRightToBracketRound = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.114 19.227a1 1 0 0 1 1-1h3.667v-12h-3.667a1 1 0 1 1 0-2h4.667a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4.667a1 1 0 0 1-1-1Zm-3.595-1.625a1 1 0 0 1-.001-1.414l2.957-2.96H4.78a1 1 0 1 1 0-2h7.7L9.52 8.267a1 1 0 1 1 1.413-1.415l4.667 4.662a1 1 0 0 1 0 1.414L10.934 17.6a1 1 0 0 1-1.414 0Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowRightToBracketRound);
export default Memo;
